// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ECXy","questions":"styles_questions__LMd7k","footer":"styles_footer__3jd1d"};